/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SwitchField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getUserBankAccount } from "../graphql/queries";
import { updateUserBankAccount } from "../graphql/mutations";
const client = generateClient();
export default function UserBankAccountUpdateForm(props) {
  const {
    id: idProp,
    userBankAccount: userBankAccountModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    bankName: "",
    accountTitle: "",
    accountNumber: "",
    isActive: false,
  };
  const [bankName, setBankName] = React.useState(initialValues.bankName);
  const [accountTitle, setAccountTitle] = React.useState(
    initialValues.accountTitle
  );
  const [accountNumber, setAccountNumber] = React.useState(
    initialValues.accountNumber
  );
  const [isActive, setIsActive] = React.useState(initialValues.isActive);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = userBankAccountRecord
      ? { ...initialValues, ...userBankAccountRecord }
      : initialValues;
    setBankName(cleanValues.bankName);
    setAccountTitle(cleanValues.accountTitle);
    setAccountNumber(cleanValues.accountNumber);
    setIsActive(cleanValues.isActive);
    setErrors({});
  };
  const [userBankAccountRecord, setUserBankAccountRecord] = React.useState(
    userBankAccountModelProp
  );
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getUserBankAccount.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getUserBankAccount
        : userBankAccountModelProp;
      setUserBankAccountRecord(record);
    };
    queryData();
  }, [idProp, userBankAccountModelProp]);
  React.useEffect(resetStateValues, [userBankAccountRecord]);
  const validations = {
    bankName: [{ type: "Required" }],
    accountTitle: [{ type: "Required" }],
    accountNumber: [{ type: "Required" }],
    isActive: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          bankName,
          accountTitle,
          accountNumber,
          isActive: isActive ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updateUserBankAccount.replaceAll("__typename", ""),
            variables: {
              input: {
                id: userBankAccountRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "UserBankAccountUpdateForm")}
      {...rest}
    >
      <TextField
        label="Bank name"
        isRequired={true}
        isReadOnly={false}
        value={bankName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              bankName: value,
              accountTitle,
              accountNumber,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.bankName ?? value;
          }
          if (errors.bankName?.hasError) {
            runValidationTasks("bankName", value);
          }
          setBankName(value);
        }}
        onBlur={() => runValidationTasks("bankName", bankName)}
        errorMessage={errors.bankName?.errorMessage}
        hasError={errors.bankName?.hasError}
        {...getOverrideProps(overrides, "bankName")}
      ></TextField>
      <TextField
        label="Account title"
        isRequired={true}
        isReadOnly={false}
        value={accountTitle}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              bankName,
              accountTitle: value,
              accountNumber,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.accountTitle ?? value;
          }
          if (errors.accountTitle?.hasError) {
            runValidationTasks("accountTitle", value);
          }
          setAccountTitle(value);
        }}
        onBlur={() => runValidationTasks("accountTitle", accountTitle)}
        errorMessage={errors.accountTitle?.errorMessage}
        hasError={errors.accountTitle?.hasError}
        {...getOverrideProps(overrides, "accountTitle")}
      ></TextField>
      <TextField
        label="Account number"
        isRequired={true}
        isReadOnly={false}
        value={accountNumber}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              bankName,
              accountTitle,
              accountNumber: value,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.accountNumber ?? value;
          }
          if (errors.accountNumber?.hasError) {
            runValidationTasks("accountNumber", value);
          }
          setAccountNumber(value);
        }}
        onBlur={() => runValidationTasks("accountNumber", accountNumber)}
        errorMessage={errors.accountNumber?.errorMessage}
        hasError={errors.accountNumber?.hasError}
        {...getOverrideProps(overrides, "accountNumber")}
      ></TextField>
      <SwitchField
        label="Is active"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isActive}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              bankName,
              accountTitle,
              accountNumber,
              isActive: value,
            };
            const result = onChange(modelFields);
            value = result?.isActive ?? value;
          }
          if (errors.isActive?.hasError) {
            runValidationTasks("isActive", value);
          }
          setIsActive(value);
        }}
        onBlur={() => runValidationTasks("isActive", isActive)}
        errorMessage={errors.isActive?.errorMessage}
        hasError={errors.isActive?.hasError}
        {...getOverrideProps(overrides, "isActive")}
      ></SwitchField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || userBankAccountModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || userBankAccountModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
